import { render, staticRenderFns } from "./BarChartTicketCount.vue?vue&type=template&id=256c46a9&"
import script from "./BarChartTicketCount.vue?vue&type=script&lang=js&"
export * from "./BarChartTicketCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports